import { attributesByGroup } from "components/attributes/lib/attribute-data";

export const formatAttributeGroups = (data) => {
    const attributeGroups = attributesByGroup(data.subGroups);

    return {
        byGroup: attributeGroups.byGroup,
        groups: attributeGroups.groups,
        subGroups: {},
        groupLabel: data.groupLabel || null,
        updatedOn: data.updatedOn,
        updatedBy: data.updatedBy,
    };
};
